export var SyncStatus;
(function (SyncStatus) {
    SyncStatus["RUNNING"] = "running";
    SyncStatus["COMPLETED"] = "completed";
    SyncStatus["FAILED"] = "failed";
})(SyncStatus || (SyncStatus = {}));
export var MovementStatus;
(function (MovementStatus) {
    MovementStatus["UNREAD"] = "unread";
    MovementStatus["READ"] = "read";
    MovementStatus["DELETED"] = "deleted";
    MovementStatus["DISCARDED"] = "discarded";
})(MovementStatus || (MovementStatus = {}));
